import React from 'react';
import { Box, Divider, IconButton, Paper, Stack, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { AutoCompleteSelectUI, ButtonUI, FormLabelUI, InputUI } from '../../Interface';

const Field = ({ label, children }) => {
  return (
    <Box>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          display: 'block',
          mb: 0.5,
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>

      {children}
    </Box>
  );
};

const ProductionReceiptMobileCards = ({
  docLines,
  selectedValues,
  cardData,
  reportData,
  setReportData,
  autoCompleteOptions,
  printingLineId,
  handleQuantityChange,
  handleBatchEdit,
  handleLabelQuantityChange,
  handlePrintLabel,
  isBatchManagedLine,
}) => {
  return (
    <Stack spacing={2} sx={{ mt: 2, mb: -5 }}>
      {docLines.map((line, index) => {
        const isMainLine = index === 0;
        const isBatchManaged = isBatchManagedLine(line);

        return (
          <Box key={line.id}>
            {!isMainLine && index === 1 && (
              <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1 }}>
                Selejt
              </Typography>
            )}

            <Paper
              variant="outlined"
              sx={{
                p: 1,
                borderRadius: 2,
              }}
            >
              <Stack spacing={2}>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Cikk
                  </Typography>

                  <Typography fontWeight={700}>{line.itemCode}</Typography>
                  <Typography variant="body2">{line.itemName}</Typography>
                </Box>

                {isMainLine && (
                  <Field label="Gyártandó / eddig készletre vett mennyiség">
                    <Typography>
                      {`${selectedValues.productionQuantity} ${cardData.articleQtyCode} / ${selectedValues.completedQuantity} ${cardData.articleQtyCode}`}
                    </Typography>
                  </Field>
                )}

                <Divider />

                <Stack direction="row" spacing={1.5} alignItems="flex-end">
                  <Box sx={{ flex: 1 }}>
                    <InputUI
                      label={<FormLabelUI text="Jó mennyiség" />}
                      fullWidth
                      type="number"
                      value={line.qty}
                      onChange={(event) => handleQuantityChange(line.id, event.target.value)}
                      inputProps={{ min: 0 }}
                      size="small"
                    />
                  </Box>

                  <Box sx={{ minWidth: 50, pb: 1 }}>
                    <Typography variant="body2" fontWeight={600} textAlign="center">
                      {line.quantityUnitCode}
                    </Typography>
                  </Box>
                </Stack>

                <InputUI
                  label={<FormLabelUI text="Selejt mennyiség" />}
                  fullWidth
                  type="number"
                  value={reportData.scrapQuantity}
                  onChange={(event) =>
                    setReportData((prev) => ({
                      ...prev,
                      scrapQuantity: event.target.value,
                    }))
                  }
                  inputProps={{ min: 0 }}
                  size="small"
                />

                <AutoCompleteSelectUI
                  label={<FormLabelUI text="Selejt ok" />}
                  onChange={(_event, newValue, reason) => {
                    setReportData((prev) => ({
                      ...prev,
                      scrapReasonId: reason === 'clear' ? null : newValue?.value,
                    }));
                  }}
                  selectedValue={reportData.scrapReasonId}
                  variant="outlined"
                  size="small"
                  dataset={autoCompleteOptions.scrap}
                />

                <InputUI
                  label={<FormLabelUI text="Megjegyzés" />}
                  fullWidth
                  value={reportData.description}
                  onChange={(event) =>
                    setReportData((prev) => ({
                      ...prev,
                      description: event.target.value,
                    }))
                  }
                  size="small"
                  multiline
                  rows={2}
                />

                {isBatchManaged && (
                  <>
                    <Divider />

                    <Field label="Sarzs">
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        sx={{
                          minHeight: 40,
                        }}
                      >
                        <Typography
                          sx={{
                            flex: 1,
                            overflowWrap: 'anywhere',
                          }}
                        >
                          {line.docLineBatchSn?.[0]?.batchSn ?? 'asd'}
                        </Typography>

                        <IconButton size="small" onClick={() => handleBatchEdit(index)}>
                          <EditIcon />
                        </IconButton>
                      </Stack>
                    </Field>

                    <Field label="Példányszám">
                      <InputUI
                        fullWidth
                        type="number"
                        value={line.labelQuantity}
                        onChange={(event) => handleLabelQuantityChange(line.id, event.target.value)}
                        inputProps={{ min: 1, step: 1 }}
                        size="small"
                      />
                    </Field>

                    <ButtonUI
                      text={printingLineId === line.id ? 'Nyomtatás...' : 'Címke nyomtatása'}
                      className="bg-success"
                      onClick={() => handlePrintLabel(line)}
                      disabled={!line.docLineBatchSn?.[0]?.batchSn?.trim() || printingLineId === line.id}
                    />
                  </>
                )}
              </Stack>
            </Paper>
          </Box>
        );
      })}
    </Stack>
  );
};

export default ProductionReceiptMobileCards;
